import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import styles from './confirmRenewDialog.module.scss'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useMutation } from '@apollo/client'
import { RESET_AUTO_LINK } from '@/modules/API/software/autoLinkHandler'
import { RESET_STAFF_AUTO_LINK } from '@/modules/API/software/staffAutoLinkHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmRenewDialogProps {
    open: boolean
    closeDialog: () => void
    daycareId: number
    renewAutoLink: (autoLink: string) => void
    staffLink?: boolean
}

const ConfirmRenewDialog: FunctionComponent<ConfirmRenewDialogProps> = ({
    open,
    closeDialog,
    daycareId,
    renewAutoLink,
    staffLink = false
}) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [resetAutoLink] = useMutation(RESET_AUTO_LINK, {
        variables: {
            daycareId: Number(daycareId)
        },
        onCompleted: ({ resetAutoLink }): void => {
            renewAutoLink(resetAutoLink)

            showNotificationSuccess(t('autoLinkRenewed'))
            closeDialog()
        },
        onError: (): void => {
            showNotificationError(t('autoLinkRenewedError'))
        }
    })

    const [resetStaffAutoLink] = useMutation(RESET_STAFF_AUTO_LINK, {
        variables: {
            daycareId: Number(daycareId)
        },
        onCompleted: ({ resetStaffAutoLink }): void => {
            renewAutoLink(resetStaffAutoLink)

            showNotificationSuccess(t('autoLinkRenewed'))
            closeDialog()
        },
        onError: (): void => {
            showNotificationError(t('autoLinkRenewedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={closeDialog} className={styles.DialogAdd}>
            <DialogHeader title={t('renew')}></DialogHeader>
            <DialogBody className={styles.DialogBody}>
                <div className={styles.TextContainer}>
                    <p className={styles.Text}>{t('renewAutoLinkConfirm')}</p>
                    <p className={styles.Text}>{t('noRollBack')}</p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'cancel'} onClick={closeDialog} className={styles.Button} />
                    <ButtonTextIcon
                        type={'confirm'}
                        onClick={staffLink ? resetStaffAutoLink : resetAutoLink}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmRenewDialog
